module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/mirror-699e37cfaf65bbcf91775d224f1dbc4a.svg";